import { useState, useEffect, useCallback } from "react";

const SCRATCHPAD_STORAGE_KEY = "python-playground-scratchpad-content";

export const useScratchpadPersistence = () => {
	const [content, setContent] = useState<string>("");
	const [isLoaded, setIsLoaded] = useState(false);

	// Load content from localStorage on mount
	useEffect(() => {
		try {
			const savedContent = localStorage.getItem(SCRATCHPAD_STORAGE_KEY);
			if (savedContent) {
				setContent(savedContent);
			}
		} catch (error) {
			console.warn(
				"Failed to load scratchpad content from localStorage:",
				error,
			);
		} finally {
			setIsLoaded(true);
		}
	}, []);

	// Save content to localStorage whenever it changes
	const updateContent = useCallback((newContent: string) => {
		setContent(newContent);
		try {
			localStorage.setItem(SCRATCHPAD_STORAGE_KEY, newContent);
		} catch (error) {
			console.warn("Failed to save scratchpad content to localStorage:", error);
		}
	}, []);

	// Clear content and localStorage
	const clearContent = useCallback(() => {
		setContent("");
		try {
			localStorage.removeItem(SCRATCHPAD_STORAGE_KEY);
		} catch (error) {
			console.warn(
				"Failed to clear scratchpad content from localStorage:",
				error,
			);
		}
	}, []);

	return {
		content,
		updateContent,
		clearContent,
		isLoaded,
	};
};
